export default "__VITE_ASSET__MUaZemcb__"